import axios from "axios";
export const URL = process.env.REACT_APP_DEV_URL;


const axiosInstance = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
